import { inject, Injectable } from '@angular/core';
import { storageKeys } from '../../constants/constant';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  router = inject(Router);
  constructor() { }

  /**
   * This function is used to set profile in local.
   * @param data 
   */
  setProfile(data: any) {
    localStorage.setItem(storageKeys.profile, JSON.stringify(data));
  }

  /**
   * This function is used to get profile.
   * @returns 
   */
  getProfile() {
    const profile = localStorage.getItem(storageKeys.profile);
    return profile ? JSON.parse(profile) : null;
  }

  setProfileImg(imageUrl: any) {
    localStorage.setItem(storageKeys.profileImage, imageUrl);
  }

  setAdminName(name: any) {
    localStorage.setItem(storageKeys.name, name);
  }

  getAdminName() {
    return localStorage.getItem(storageKeys.name);
  }

  getProfileImg() {
    return localStorage.getItem(storageKeys.profileImage);
  }

  setAuthToken(data: any) {
    localStorage.setItem(storageKeys.authTokenKey, JSON.stringify(data));
  }

  getAuthToken() {
    const token = localStorage.getItem(storageKeys.authTokenKey);
    return token ? JSON.parse(token) : null;
  }

  setUserId(data: any) {
    localStorage.setItem(storageKeys.userId, data);
  }

  getUserId() {
    return localStorage.getItem(storageKeys.userId);
  }

  setForgotEmail(email: any) {
    localStorage.setItem(storageKeys.forgotEmail, email);
  }

  getForgotEmail() {
    const email = localStorage.getItem(storageKeys.forgotEmail);
    return email ? email : null;
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/auth/login');
  }
}
